import React from 'react';
import AnimatedText from 'react-animated-text-content';
import AOS from 'aos';
import profe from '../../../../Images/BannerNewAdd/profe.png'
import NavBar from '../../NavBar/NavBar';
import Footer from '../../Footer/Footer';

AOS.init();

const ProfessionalWorkers = () => {

    return (
        <div className='all-background'>
            <div>
                <NavBar />
            </div>
            <div className='welcom-sector text-center'>
                <div className='container'>
                    <h4 style={{ backgroundColor: "black", borderRadius: "20px 20px 0px 0px", color: "white", padding: "15px" }}><AnimatedText type="char" animationType="float" interval={0.07} duration={0.9}>Professional Worker</AnimatedText></h4>
                    <div className='margue-section-2'>
                   <div className='mt-5 mb-5'>
                
                    <div className="row">
                        <div className="col-md-12 text-center">
                        <img src={profe} alt="" />
                        </div>
                    </div>
                    <br />
                    <br />
                    <br />
                    <div className="row">
                        <div className="col-md-12" style={{textAlign: "justify", padding: "10px 60px 20px 60px", fontSize: "15px"}}>
                            <p>Professional workers are an evolution of a person’s proficiency. Has the standards of education and training that prepare members of the profession with the particular knowledge and skills necessary to perform their specific role within that profession.</p>
                        </div>
                    </div>

                   </div>
                    </div>
                </div>
            </div>
            <div className='mt-5'>
                <Footer />
            </div>
        </div>
    );
};

export default ProfessionalWorkers;